(ns minorodata.file-ingest.utils
  (:require [clojure.string :as str]))


(def reserved-names
  #{"ignore" "else" "table" "percent" "permissions" "analyse" "recover"
    "encrypt" "localtimestamp" "values" "unique" "rename" "using"
    "trailing" "right" "freeze" "placing" "localtime" "top" "collate"
    "of" "cast" "wallet" "off" "offset" "rejectlog" "cluster"
    "references" "backup" "delete" "resort" "not" "encryption"
    "mostly32" "intersect" "group" "parallel" "natural" "current_date"
    "by" "long" "emptyasnull" "is" "delta" "cross" "null" "like" "user"
    "binary" "union" "lzop" "grant" "new" "without" "gzip" "offline"
    "option" "enable" "lun" "partition" "where" "timestamp" "for"
    "increment" "snapshot" "text255" "overlaps" "truncatecolumns"
    "minus" "session_user" "update" "alter" "globaldict64k" "exclusive"
    "bytedict" "analyze" "any" "distinct" "immediate" "oid" "leading"
    "false" "limit" "tag" "modify" "check" "similar" "drop"
    "current_user" "both" "full" "connect" "nulls" "regexp" "outer"
    "select" "primary" "or" "lzo" "identity" "start" "case" "disable"
    "true" "current_timestamp" "on" "desc" "current" "old" "mostly13"
    "when" "allowoverwrite" "asc" "having" "deferrable" "tablesample"
    "and" "order" "column" "text32k" "delta32k" "explicit" "do"
    "authorization" "blanksasnull" "whenever" "row" "between" "rlike"
    "isnull" "from" "join" "insert" "notnull" "luns" "lock" "create"
    "aes256" "current_time" "with" "ilike" "set" "inner" "foreign"
    "some" "tdes" "bzip2" "deflate" "all" "exists" "maxextents" "then"
    "system" "rows" "globaldict256" "restore" "sysdate" "raw" "open"
    "respect" "current_user_id" "defrag" "only" "to" "trigger"
    "credentials" "into" "mostly8" "except" "encode" "default"
    "lateral" "as" "array" "readratio" "revoke" "end" "verbose" "left"
    "sample" "constraint" "in" "initially" "aes128"})


(defn check-field [field]
  (if (reserved-names field)
    (str field "_")
    field))


(defn conform-header [hdr]
  (let [conformed (-> hdr
                      str/trim
                      (str/replace #"^[0-9]" (fn [m]
                                               (str "_" m)))
                      (str/replace #"\W" "_")
                      (str/replace #"\p{C}" "")
                      str/lower-case
                      check-field)
        conformed-length (count conformed)]
    (cond
      (>= conformed-length 127)             (subs conformed 0 (- conformed-length 3))
      (and (= conformed-length 1)
           (re-matches #"[\d_]" conformed)) (str conformed "_column")
      :else conformed)))


(defn conform-headers [headers]
  (->> headers
       (reduce (fn [{:keys [empty-index _] :as acc} header]
                 (if (or (nil? header)
                         (str/blank? header))
                   (-> acc
                       (update :empty-index inc)
                       (update :hdrs conj (str "empty_column_"
                                               (inc empty-index))))
                   (update acc :hdrs
                           conj (conform-header header))))
               {:empty-index 0
                :hdrs        []})
       :hdrs))


(defn mark-duplicate-headers [headers]
  (->> headers
       (reduce (fn [{:keys [dict indices] :as acc} header]
                 (let [contained? (contains? dict header)
                       index (get indices header)]
                   (if (and contained?
                            (some? index))
                     (loop [new-header (str header "_" index)
                            new-index index]
                       (if (contains? dict new-header)
                         (recur (str header "_" (inc new-index))
                                (inc new-index))
                         (-> acc
                             (update :hdrs conj new-header)
                             (assoc-in [:indices header] (inc new-index)))))
                     (-> acc
                         (update :hdrs conj header)
                         (assoc-in [:indices header] (inc index))))))
               {:dict    (set headers)
                :indices {}
                :hdrs    []})
       :hdrs))


(defn suggest-headers [headers]
  (->> headers
       conform-headers
       mark-duplicate-headers
       (mapv #(str/replace % #"__+" "_"))
       mark-duplicate-headers))


(def not-alphanumeric-or-underscore
  #"[^a-zA-Z\d_]")


(defn valid-header? [headers new-header]
  (let [message (cond
                  (nil? new-header) "Header shouldn't be empty"
                  (str/blank? new-header) "Header shouldn't be an empty string"
                  (contains? (set headers) new-header) "Duplicate header"
                  (contains? reserved-names new-header) "This is a reserved word. Try a different header"
                  (re-matches #"^[0-9]+.*" new-header) "Header can't start with a number"
                  (re-find not-alphanumeric-or-underscore new-header) "Header could contain only letters, numbers and _")]
    (if (some? message)
      [false message]
      [true nil])))


(defn valid-table-name? [tables new-table]
  (let [conformed-name (-> new-table
                           str/trim
                           (str/replace not-alphanumeric-or-underscore "_")
                           (str/replace #"\p{C}" ""))
        message (cond
                  (str/blank? new-table) "Table name shouldn't be an empty string"
                  (re-matches #"^[0-9]+.*" new-table) "Table name can't start with a number"
                  (re-find not-alphanumeric-or-underscore new-table) "Table name could contain only letters, numbers and _"
                  (contains? tables (str/upper-case conformed-name)) (str "Table `" new-table "` already exists")
                  (contains? reserved-names (str/lower-case conformed-name)) "This is a reserved word. Try a different table name")]
    (if (some? message)
      [false message]
      [true nil])))

